import { dev } from '$app/environment';
import { clientErrorSDK } from '@pineapple/shared/utils/client-error-sdk';
import { classifyError, shouldReportError } from '@pineapple/shared/utils/error-handler';

export const handleError: import('@sveltejs/kit').HandleClientError = ({
  error,
  status,
  message,
}) => {
  if (shouldReportError(status)) {
    const err = error instanceof Error ? error : new Error(String(error));
    clientErrorSDK.reportError({
      error_message: err.message,
      traceback: err.stack,
      url: window.location.href,
      referrer: document.referrer,
      user_agent: navigator.userAgent,
      error_type: classifyError(status),
      status,
      breadcrumbs: [],
    });
  }
  // The reporter sends the real error to the ingest endpoint over sendBeacon,
  // and SvelteKit shows the user a generic page. That combination means a
  // failure during development leaves nothing in the console and nothing in the
  // network panel — the error page is all you get. Log it while developing.
  if (dev) console.error('[handleError]', status, error);

  return { message: message ?? 'An unexpected error occurred.' };
};
